
export enum LOG_LEVEL {
    MILESTONE   = 1,
    TRACE       = 2,
    VERBOSE     = 3,
    INFO        = 4,
    WARN        = 5,
    ERROR       = 6,
    FATAL       = 7,
};

export interface ILogger {
    log: (logLevel: LOG_LEVEL, message: string) => void;
}

// settings: IConfigLogSettings, 